const URL_TRAILING_PUNCTUATION_RE = /[.,!?、。]+$/;

const parseStageSeatingUrl = (rawUrl) => {
  const source = String(rawUrl || '').trim();
  if (!source) return null;
  const isAbsolute = /^https?:\/\//i.test(source);
  const base = 'https://casticart.local';
  try {
    const url = new URL(source, base);
    const segments = url.pathname.split('/').filter(Boolean);
    const hasStageSeatingHash = url.hash === '#stage-seating';
    const stageSeatingIndex = segments.indexOf('stage-seating');
    let eventId = '';

    for (let index = 0; index < segments.length; index += 1) {
      const segment = segments[index];
      if (segment === 'event-details' && segments[index + 1]) {
        eventId = segments[index + 1];
        break;
      }
      if (segment === 'events' && segments[index + 1] && segments[index + 1] !== 'event-details') {
        eventId = segments[index + 1];
        break;
      }
    }

    if (!eventId || (!hasStageSeatingHash && stageSeatingIndex < 0)) return null;
    return {
      eventId: decodeURIComponent(eventId),
      isAbsolute,
      origin: isAbsolute ? url.origin : '',
      layoutId:
        url.searchParams.get('layout_id') ||
        url.searchParams.get('layoutId') ||
        url.searchParams.get('layout') ||
        '',
    };
  } catch {
    return null;
  }
};

export const normalizeStageSeatingShareUrlForAdmin = (rawUrl) => {
  const source = String(rawUrl || '').trim();
  if (!source) return '';
  const suffixMatch = source.match(URL_TRAILING_PUNCTUATION_RE);
  const suffix = suffixMatch?.[0] || '';
  const sourceWithoutSuffix = suffix ? source.slice(0, -suffix.length) : source;
  const parsed = parseStageSeatingUrl(sourceWithoutSuffix);
  if (!parsed) return source;

  const path = `/admin/workspaces/event-operations/events/${encodeURIComponent(parsed.eventId)}/stage-seating/preview`;
  const query = parsed.layoutId ? `?layout_id=${encodeURIComponent(parsed.layoutId)}` : '';
  return `${parsed.origin}${path}${query}${suffix}`;
};

export const replaceStageSeatingShareUrlsForAdmin = (text) => {
  const source = String(text || '');
  if (!source) return source;
  return source.replace(/https?:\/\/[^\s]+/g, (url) => normalizeStageSeatingShareUrlForAdmin(url));
};
